/* @jsx h */
import { defineComponent, h, ref, onMounted, onUnmounted, computed } from "vue";

function getRelativeTime(date: Date): string {
  const diffMs = Date.now() - date.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  if (diffSec < 60) return `${diffSec}s ago`;
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHrs = Math.floor(diffMin / 60);
  if (diffHrs < 24) return `${diffHrs}h ago`;
  const diffDays = Math.floor(diffHrs / 24);
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString();
}

export type RelativeTimeLabelProps = {
  datetime: string;
  class?: string;
};

export const RelativeTimeLabel = defineComponent<RelativeTimeLabelProps>({
  name: "RelativeTimeLabel",
  props: ["datetime", "class"],
  setup(props) {
    const tick = ref(0);
    let interval: ReturnType<typeof setInterval>;

    onMounted(() => {
      interval = setInterval(() => {
        tick.value++;
      }, 30_000);
    });
    onUnmounted(() => clearInterval(interval));

    const date = computed(() => new Date(props.datetime));
    const relative = computed(() => {
      tick.value;
      return getRelativeTime(date.value);
    });
    const localStr = computed(() => date.value.toLocaleString());
    const utcStr = computed(() => date.value.toUTCString());

    return () => (
      <span
        class={`relative inline-block group cursor-default select-none ${props.class ?? ""}`}
      >
        <span class="border-b border-dashed border-base-content/30">
          {relative.value}
        </span>
        <span
          class="pointer-events-none absolute bottom-full left-0 mb-2 z-50 hidden group-hover:flex flex-col gap-1 bg-base-300 border border-base-content/20 rounded-xl px-3 py-2 text-xs whitespace-nowrap shadow-xl"
          style="min-width: 200px"
        >
          <span class="text-base-content font-medium">{localStr.value}</span>
          <span class="text-base-content/50">UTC: {utcStr.value}</span>
        </span>
      </span>
    );
  },
});
